export const GIFTING_CART_ERROR_CROUTON_HIDE_DELAY = 5000;
